import colorAxis from './colorAxis'
const dataDisplayOptions = [
  {
    label: 'Public Indicators',
    options: [
      {
        value: 'threshold_level',
        tagKey: 'threshold_level',
        tagValue: 'rate_per_100k',
        label: 'Incident Rate',
        colorAxis: colorAxis,
        mapTitle: 'US Incident Rate',
        mapSubTitle: undefined,
        indicatorName: 'birthtrend',
        legend: {
          enabled: false,
          title: {
            text: 'US Incident Rate',
          },
        },
      },
    ],
  },
]

export default dataDisplayOptions
